import React from 'react';
import { Button } from './Button';
interface GoldButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  mainText: string;
  subText?: string;
  className?: string;
}
export function GoldButton({
  mainText,
  subText,
  className = '',
  ...props
}: GoldButtonProps) {
  return <Button className={`
        group relative overflow-hidden rounded-full bg-brand-gold hover:bg-[#d4b455] 
        text-black font-display font-bold uppercase transition-all duration-300 
        hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(201,167,70,0.4)]
        h-auto py-3 px-8 flex flex-col items-center justify-center gap-0.5
        ${className}
      `} {...props} data-id="element-80">
      <span className="text-lg md:text-xl tracking-wide z-10" data-id="element-81">{mainText}</span>
      {subText && <span className="text-[10px] md:text-xs font-body font-semibold tracking-wider opacity-80 z-10" data-id="element-82">
          {subText}
        </span>}

      {/* Shine sweep on hover only — single pass, no infinite animation */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-full z-0" data-id="element-83" />
    </Button>;
}